import { AnalyticsSummary } from "@:openapi";

export const summarySelector = (data: AnalyticsSummary) => {
  return {
    activeUsersPeriod: data.activeUsersPeriod.reduce(
      (sum, user) => sum + user.numLogins,
      0,
    ),
    activeUsersPeriodData: data.activeUsersPeriod,
    activeUsersPeriodDistinct: data.activeUsersPeriodDistinct,
    requestsPeriod: data.requestsPeriod.reduce(
      (sum, request) => sum + request.numRequests,
      0,
    ),
    requestsPeriodData: data.requestsPeriod,
  };
};
